module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name !== 'recipe'),
      expression: "this.$route.name !== 'recipe'"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Plus")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Notre équipe")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/orgs/tradfood/teams",
      "target": "_blank"
    }
  }, [_vm._v("Qui sommes-nous ?")])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Abonnez-vous !")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://tradfood.us17.list-manage.com/subscribe/post?u=aeeb4785daf341646eb4140fa&id=bf0f9b5385",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('div', {
    staticClass: "mc-field-group"
  }, [_c('input', {
    staticClass: "required email",
    attrs: {
      "type": "email",
      "value": "",
      "placeholder": "Email",
      "name": "EMAIL",
      "id": "mce-EMAIL"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear",
    attrs: {
      "id": "mce-responses"
    }
  }, [_c('div', {
    staticClass: "response",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mce-error-response"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "response",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mce-success-response"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_aeeb4785daf341646eb4140fa_bf0f9b5385",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Envoyer",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Contactez-nous")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:contact@tradfood.fr"
    }
  }, [_vm._v("contact@tradfood.fr")]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://twitter.com/tradfood",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "instagram",
    attrs: {
      "href": "https://www.instagram.com/tradfoodfr/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/tradfoodfr/",
      "target": "_blank"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a992702e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 71
// module chunks = 1